import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeHelp } from '../../actions/help';
import {
    DraggableHelp,
    DraggableHelpProps
} from '../../components/DraggableHelp/DraggableHelp';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<DraggableHelpProps>;

type DispatchProps = TDispatchProps<DraggableHelpProps>;

const mapStateToProps = (state: State): StateProps => {
    const { opened, helpId = '' } = state.help;
    const { tooltips } = state.grid;

    const text = tooltips[helpId];

    return {
        isVisible: opened,
        isProgress: text === undefined,
        text
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClose: () => {
            dispatch(closeHelp);
        }
    };
};

export const DraggableHelpContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(DraggableHelp);
